export enum ColorValuesEnum {
  White = 'white', // Biały
  SkyBlue = 'skyBlue', // Błękitny
  Brown = 'brown', // Brązowy
  Black = 'black', // Czarny
  Red = 'red', // Czerwony
  Violet = 'violet', // Fioletowy
  Copper = 'copper', // Miedziany
  Blue = 'blue', // Niebieski
  Orange = 'orange', // Pomarańczowy
  Pink = 'pink', // Różowy
  Silver = 'silver', // Srebrny
  Gray = 'gray', // Szary
  Green = 'green', // Zielony
  Gold = 'gold', // Złoty
  Yellow = 'yellow', // Żółty
  Achromatic = 'achromatic', // Achromatyczny
  Multicolor = 'multicolor', // Multikolor
  Metallic = 'metallic' // Metaliczny
}
